<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="mb-4">
                <h1 class="text-first">
                    {{ $t('Auth.Login.RouteName') }}
                </h1>
            </div>
            <form class="shadow rounded p-4 mb-4" @submit.prevent="login">
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="email" class="border-bottom" id="email" :class="{'text-danger' : errors.email}" required>
                        <label for="email" :class="{'text-danger' : errors.email}">
                            <i class="fa-solid fa-envelope me-1"></i>
                            {{ $t('Auth.Login.email') }}
                            <small v-if="errors.email" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="passwordShowed === false ? 'password' : 'text'" v-model="password" class="border-bottom" id="password" :class="{'text-danger' : errors.password}" required>
                        <label for="password" :class="{'text-danger' : errors.password}">
                            <i class="fa-solid fa-lock me-1"></i>
                            {{ $t('Auth.Login.password') }}
                            <small class="text-danger" v-if="errors.password">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle" role="button" @click="passwordShowed = !passwordShowed">
                            <i class="fa-solid" :class="passwordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <button type="submit" class="btn btn-auth btn-auth-third w-100">
                    {{ $t('Auth.Login.login') }}
                </button>
            </form>
            <div class="d-flex align-items-center flex-wrap shadow rounded p-4 mb-4">
                <h5 class="text-second me-4">
                    {{ $t('Auth.Login.login_with') }}:
                </h5>
                <GoogleLogin class="btn-auth btn-auth-third py-2 px-3 me-4" :callback="loginWithGoogle">
                    <img src="@/assets/img/google-ico.png">
                </GoogleLogin>
                <span class="text-white bg-facebook py-2 px-3" role="button" @click="loginWithFacebook">
                    <i class="fa-brands fa-facebook fs-4"></i>
                </span>
            </div>
            <div class="shadow rounded p-4">
                <div class="mb-4">
                    <router-link to="/sign/up" class="text-second">
                        {{ $t('Auth.Login.sign_up') }}
                    </router-link>
                </div>
                <div class="mb-4">
                    <router-link to="/forgot_password" class="text-second">
                        {{ $t('Auth.Login.forgot_password') }}
                    </router-link>
                </div>
                <router-link to="/resend_confirmation_email" class="text-second">
                    {{ $t('Auth.Login.resend_confirmation_email') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'LoginView',
    computed: {
        ...mapState(['facebookSdk']),
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            email: null,
            password: null,
            passwordShowed: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setAccount']),
        login() {
            this.errors = {}
            this.$http
                .post(`${this.apiPath}/login`, { email: this.email, password: this.password }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.Login.errors.email.${error.msg}`)
                            }
                            if (error.path == 'password') {
                                this.errors.password = this.$t(`Auth.Login.errors.password.${error.msg}`)
                            }
                        }
                    } else if (res.data.account) {
                        this.setAccount(res.data.account)
                        this.$router.go('/dashboard')
                    } else {
                        switch (res.data) {
                            case 'No Account Found':
                                this.errors.email = this.$t('Auth.Login.errors.email.NoAccountFound')
                                break
                            case 'Password Incorrect':
                                this.errors.password = this.$t('Auth.Login.errors.password.invalid')
                                break
                            case 'Unconfirmed Email':
                                this.$toast.info(`<h4 class="mb-2">${this.$t('Auth.EmailUnconfirmed.confirm_required')}</h4> <h6>${this.$t('Auth.EmailUnconfirmed.login_again')}</h6>`)
                                break
                            case 'use_google_login_method':
                                this.$toast.info(`<h4>${this.$t('toast.use_google_login_method')}</h4>`)
                                break
                            case 'use_facebook_login_method':
                                this.$toast.info(`<h4>${this.$t('toast.use_facebook_login_method')}</h4>`)
                                break
                            case 'use_social_login_method':
                                this.$toast.info(`<h4>
                                    ${this.$t('Auth.Login.login_with')}
                                    <i class="fa-brands fa-google fs-4 mx-2"></i>
                                    <i class="fa-brands fa-facebook fs-4"></i>
                                    </h4>`)
                                break
                        }
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        },
        loginWithGoogle(response) {
            this.$http
                .post(`${this.apiPath}/login_with_google`, {response}, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.account) {
                        this.setAccount(res.data.account)
                        this.$router.go('/dashboard')
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        },
        loginWithFacebook() {
            this.facebookSdk.FB
                .login((res) => {
                    if (res.status === 'connected') {
                        this.facebookSdk.FB
                            .api(`/${res.authResponse.userID}`, {fields: ['first_name', 'last_name', 'email']}, (profile) => {
                                this.$http
                                    .post(`${this.apiPath}/login_with_facebook`, {profile}, {
                                        headers: {
                                            'x-api-key': this.omsApiKey
                                        }
                                    })
                                    .then((res) => {
                                        if (res.data.account) {
                                            this.setAccount(res.data.account)
                                            this.$router.go('/dashboard')
                                        }
                                    })
                                    .catch((err) => {
                                        this.setErrorFromServer(err.message)
                                    })
                            })
                    }
                },{ scope: 'email'})
        }
    }
}
</script>